import { Group, Layout, Page, Tree } from "@/comn/components";
import { useNavigate, useParams } from "react-router-dom";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { TFormSchema, useFetch, useForm, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { APIS, BASE, URLS, SF_COMN_VRFN_CTRA_INFO } from "@/tra/tancis/ptli/comnmdle/doc/services/PtliDocMgmtService";
import { useEffect } from "react";

/*
 * Common Verification Criteria Registration
 * !== 공통검증기준 등록 ==!
 */
export const PTLI0413002S = () => {
    useResource({
        defaultSchema: [
            { area: "tb" },
            { area: "col" },
            { area: "lbl" },
            { area: "comnCdMstr" },
            { area: "indvCdTb" },
            { area: "indvCdCol" },
        ],
    });

    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM"],
    });
    const navigate = useNavigate();
    const { pgeStore } = useStore({ pgeUid: pgeUid });
    const { dclaDocCd } = useParams();
    const modal = useModal();
    const toast = useToast();
    const { t } = useTranslation();

    const form = {
        comnVrfnCtraInfo: useForm({
            defaultSchema: SF_COMN_VRFN_CTRA_INFO,
        }),
    };

    const fetch = {
        createComnVrfnCtraInfo: useFetch({
            api: (data: any) => APIS.createComnVrfnCtraInfo(data),
            enabled: false,
            onSuccess: (data) => {
                if (data?.msgList?.content.length > 0) {
                    // 일반 메시지 모달
                    modal.openModal({
                        type: "messages",
                        data: data?.msgList?.content,
                    });
                } else {
                    modal.openModal({
                        content: "msg.com.00058",
                        onCancel: () => {
                            navigate(`${URLS.ptli0413001q}?menuId=${menuId}`);
                        },
                    }); // Successfully inserted. !== 정상적으로 등록되었습니다. ==!
                }
            },
            onError: (error: any) => {
                //에러 메시지 처리
                const { errorMessage } = error.response.data;
                modal.openModal({ content: errorMessage });
            },
            // onError: () => toast.showToast({ type: "error", content: "msg.com.00018" }), // An error occurred. !== 에러가 발생했습니다! ==!
        }),
    };

    const handler = {
        onRestBtnClick: () => {
            handler.clearFormState();
            form.comnVrfnCtraInfo.reset();
        },
        onListBtnClick: () => {
            navigate(`${URLS.ptli0413001q}?menuId=${menuId}`);
        },
        onSaveBtnClick: () => {
            if (!comnUtils.isEmpty(form.comnVrfnCtraInfo.errors)) {
                toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                return;
            }

            form.comnVrfnCtraInfo.handleSubmit(
                () => {
                    const data = form.comnVrfnCtraInfo.getValues();
                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.createComnVrfnCtraInfo.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" }); // Data is invalid, !== 데이터가 유효하지않습니다. ==!
                    console.log(comnUtils.isEmpty(form.comnVrfnCtraInfo.errors), form.comnVrfnCtraInfo.isSubmitted);
                },
            )();
        },
        clearFormState: () => {
            form.comnVrfnCtraInfo.clearErrors();
            form.comnVrfnCtraInfo.resetSchema();
        },
    };

    useEffect(() => {
        form.comnVrfnCtraInfo.setValue("dclaDocCd", dclaDocCd);
    }, []);

    const itmLenValdnYn = form.comnVrfnCtraInfo.watch("itmLenValdnYn") == "Y";
    const dtVldtyValdnYn = form.comnVrfnCtraInfo.watch("dtVldtyValdnYn") == "Y";
    const numDgtValdnYn = form.comnVrfnCtraInfo.watch("numDgtValdnYn") == "Y";
    const comnCdValdnYn = form.comnVrfnCtraInfo.watch("comnCdValdnYn") == "Y";
    const indvCdValdnYn = form.comnVrfnCtraInfo.watch("indvCdValdnYn") == "Y";

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Title title={t("T_COMN_INFO")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.dclaDocCd} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.docNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.comnVrfnCtraInfo.schema.trgtTbNm}
                                callback={(data) => {
                                    form.comnVrfnCtraInfo.schema.trgtColNm.popupParams.tbId = data.code;
                                }}
                                onChange={(value) => {
                                    form.comnVrfnCtraInfo.schema.trgtColNm.popupParams.tbId = value;
                                }}
                            />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.trgtColNm} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.valdnItmLblId} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Title title={t("L_VALDN_RULE")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.itmSrtngOrd} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.erkyOrd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.rqrdInpValdnYn} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.itmLenValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.itmMinLenDgt} required={itmLenValdnYn} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.itmLenDgt} required={itmLenValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.dtVldtyValdnYn} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.dtVldtyTpCn} required={dtVldtyValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.numVldtyValdnYn} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.numDgtValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.totDgt} required={numDgtValdnYn} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.dcmlUndrDgt} required={numDgtValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.amtQtyValdnYn} />
                        </Group.Row>
                    </Group.Section>
                    <Group.Title title={t("L_CD_VALDN")} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.comnCdValdnYn} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.comnCd} required={comnCdValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.indvCdValdnYn} />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.indvCdUprColNm} required={indvCdValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.comnVrfnCtraInfo.schema.indvCdTbNm}
                                callback={(data) => {
                                    form.comnVrfnCtraInfo.schema.indvCdColNm.popupParams.tbId = data.code;
                                }}
                                onChange={(value) => {
                                    form.comnVrfnCtraInfo.schema.indvCdColNm.popupParams.tbId = value;
                                }}
                                required={indvCdValdnYn}
                            />
                            <Group.Control {...form.comnVrfnCtraInfo.schema.indvCdColNm} required={indvCdValdnYn} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.comnVrfnCtraInfo.schema.indvCdAddQuryCn} required={indvCdValdnYn} />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
